import { Stack, Typography } from '@mui/material'
import { FC, useState } from 'react'
import { Button, IconButton, Icons } from 'utoniq-ui'

import { MembershipSubscriptionProduct } from '@/clients/utoniq-core/schema'
import { useRouter, useTranslation } from '@/core'

import { ArtistSideMenu, ArtistSideMenuProps } from './ArtistSideMenu'

export type ArtistHeaderItemsLeftProps = {
  currentUser: ArtistSideMenuProps['currentUser']
  paymentType: ArtistSideMenuProps['paymentType']
  hasArrangingDeliveryItems: ArtistSideMenuProps['hasArrangingDeliveryItems']
  membership: Pick<MembershipSubscriptionProduct, 'productId'>[] | undefined
}
export const ArtistHeaderItemsLeft: FC<ArtistHeaderItemsLeftProps> = ({
  currentUser,
  paymentType,
  hasArrangingDeliveryItems,
  membership,
}) => {
  const { routerPages } = useRouter()
  const [openSideMenu, setOpenSideMenu] = useState<boolean>(false)
  return (
    <>
      <Stack spacing={2} direction="row">
        <IconButton.Menu
          onClick={() => setOpenSideMenu(true)}
          edge="start"
          color="white"
          bgcolor="transparent"
        />
        <IconButton.Notice
          href={routerPages.Notifications}
          color="white"
          bgcolor="transparent"
        />
        {/**
         * @description
         * Open when function is implemented in the future
         * https://app.clickup.com/t/908127/UT-6887
         */}
        {/*<IconButton.Search href={'#'} color="white" />*/}
      </Stack>
      <ArtistSideMenu
        open={openSideMenu}
        onClose={() => setOpenSideMenu(false)}
        currentUser={currentUser}
        paymentType={paymentType}
        hasArrangingDeliveryItems={hasArrangingDeliveryItems}
        membership={membership}
      />
    </>
  )
}

export type ArtistHeaderItemsRightProps = {
  artistId: string
}
export const ArtistHeaderItemsRight: FC<ArtistHeaderItemsRightProps> = ({
  artistId,
}) => {
  const { t } = useTranslation('consoleHome')
  const { generatePath, routerPages } = useRouter()
  return (
    <Button
      sx={{ minWidth: 124, mr: -3, color: 'white' }}
      variant="text"
      href={generatePath(routerPages.ArtistTop, { artistId })}
    >
      <Icons.Window color="inherit" />
      <Typography sx={{ ml: 1 }} color="inherit" variant="subtitle1">
        {t('viewTheApp')}
      </Typography>
    </Button>
  )
}
